module.exports = __webpack_public_path__ + "img/全国残疾人两项补贴信息系统.93c2d178.jpg";